// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/closeDark.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-offcanvas.offcanvas.offcanvas-end.show {
  --bs-offcanvas-bg: var(--2b4e) !important;
  --bs-offcanvas-width: 75% !important;
}
.dark-offcanvas.offcanvas.offcanvas-end.show .btn-close {
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.offcanvas {
  --bs-offcanvas-width: 75% !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/TransactionAndStream/TransactionAndStream.scss"],"names":[],"mappings":"AAEA;EACE,yCAAA;EACA,oCAAA;AADF;AAEE;EACE,qEAAA;AAAJ;;AAGA;EACE,oCAAA;AAAF","sourcesContent":["#transactionandstream-container {\r\n}\r\n.dark-offcanvas.offcanvas.offcanvas-end.show {\r\n  --bs-offcanvas-bg: var(--2b4e) !important;\r\n  --bs-offcanvas-width: 75% !important;\r\n  .btn-close {\r\n    --bs-btn-close-bg: url(\"../../assets/images/icons/closeDark.png\") !important;\r\n  }\r\n}\r\n.offcanvas {\r\n  --bs-offcanvas-width: 75% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
